import React, { useState, useEffect, useRef } from 'react';
import { Typography, Button, Alert, Box,useMediaQuery } from '@mui/material';
import RequestForm from './RequestForm';
import Safety from './Safety';
import Shine from './Shine';
import Standardise from './Standardise';
import Straighten from './Straighten';
import Sustain from './Sustain';
import { stepState, formDataState } from '../../recoil/atoms';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import configParam from "../../config";

import { useTheme } from '@mui/material/styles';
import AlertDialog from '../input/AlertDialog';
import { CoPresent, CompassCalibrationTwoTone } from '@mui/icons-material';
import NewAssessment from './NewAssessment';
import Snackbar from '@mui/material/Snackbar';
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { useRecoilState, useResetRecoilState } from "recoil";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
function HorizontalCombinedStepper({ open ,state,assesmentid,onClose}) {
  const [shouldClose, setShouldClose] = useState(false);

  const steps = ['S1S: SORT(SEIRI)', 'Straighten', 'Shine', 'Standardise', 'Sustain', 'Safety'];
  const [activeStep, setActiveStep] = useRecoilState(stepState);

  const [formData, setFormData] = useRecoilState(formDataState);

  const [overallScore, setOverallScore] = useState(0);
  const [stepColors, setStepColors] = useState(steps.map((_, index) => index === 0 ? '#0086DC' : '#BDBDBD'));
  const [assessmentId, setAssessmentId] = useState(null);
  const [assessmentCreated, setAssessmentCreated] = useState(false);

  const [selectedAuditDate, setSelectedAuditDate] = useState(null);
  const [selectedAuditor, setSelectedAuditor] = useState('');
  const [selectedZone, setSelectedZone] = useState('');
  const [loading, setLoading] = useState(false);
  // FIX: gates rendering of the step content in edit mode until the full saved
  // record has been loaded into formDataState. Previously, step components could
  // mount and (on an empty formData[activeStep]) kick off their own fallback fetch
  // to the server, which could resolve *after* the user had already typed a new
  // value and silently overwrite it with the stale server copy. It also meant a
  // step could fall back to reading the server's flat, unscoped answer object
  // directly, double counting questions into the score. Waiting for one clean,
  // scoped hydration removes both problems.
  const [editDataLoaded, setEditDataLoaded] = useState(false);
  const ApiURL = configParam.API_URL;
  const location = useLocation();
  const access_token = JSON.parse(localStorage.getItem("accesstoken"));

  const { editedAssessment } = location.state || {};
  const [totalScore, setTotalScore] = useState(0);
  const assessmenteditflg = localStorage.getItem("assessmenteditflg") === "true";
  const { message, unselectedQuestions } = location.state || {};
  const [changesSaved, setChangesSaved] = useState(false);

  const [savedFormData, setSavedFormData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const theme = useTheme();

  const onNext = () => {
    setActiveStep(prevStep => prevStep + 1);
  };

  const contentRef = useRef(null);

  // Function to calculate the overall score across all steps


  useEffect(() => {
    // Update stepper colors based on active step
    const stepColors = steps.map((_, index) => index === activeStep ? '#0086DC' : '#BDBDBD');
    setStepColors(stepColors);

  }, [activeStep, formData]);


  
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };

  const onStepClick = (stepIndex) => {
    // Update formDataState with the current form data
    setFormData(formData);
    setActiveStep(stepIndex);
    // scroll dialog content to top when user clicks a step
    try {
      if (contentRef.current && typeof contentRef.current.scrollTo === 'function') {
        contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
    } catch (e) {
      console.warn('scroll error', e);
    }
  };



  // const onStepClick = async (stepIndex) => {
  //   // Get the current form data for the step
  //   const currentStepFormData = formData[activeStep];

  //   // Check if any radio button is selected in the current step
  //   const isStepAnswered = Object.values(currentStepFormData.selectedValues).some(value => value !== '');
  //   // Check if remarks are added in the current step
  //   const isRemarksAdded = Object.values(currentStepFormData.remarks).some(value => value !== '');
  //   // Check if images are added in the current step (you need to define this logic based on your implementation)
  //   const isImagesAdded = Object.values(currentStepFormData.images).some(value => value !== '');
  //   // Check if any changes are made but not saved in the current step
  //   const isUnsavedChanges = (isStepAnswered || isRemarksAdded || isImagesAdded) && !changesSaved;

  //   if (isUnsavedChanges) {
  //     setSnackbarMessage("Please save your changes before moving to another step.");
  //     setSnackbarOpen(true);
  //     return;
  //   }

  //   // Move to the selected step
  //   setActiveStep(stepIndex);
  // };

  //  const validateQuestion = (value) => {
  //     if (!value) {
  //       return "This field is required."; // Error message for required fields
  //     }
  //     // Add additional validation logic as needed for each question
  //     return null; // Return null if there are no validation errors
  //   };

  //   const validateFormData = async (stepIndex) => {
  //     if (stepIndex !== activeStep) {
  //       return null;
  //     }

  //     const currentStepFormData = formData[activeStep];
  //     const isStepAnswered = Object.values(currentStepFormData.selectedValues).some(value => value !== '');

  //     if (!isStepAnswered) {
  //       return null;
  //     }

  //     if (!changesSaved) {
  //       return { error: "Please save your changes before moving to another step_4." };
  //     }

  //     const formDataValidationPromises = [];
  //     for (const questionId in currentStepFormData.selectedValues) {
  //       if (currentStepFormData.selectedValues.hasOwnProperty(questionId)) {
  //         const value = currentStepFormData.selectedValues[questionId];
  //         const error = validateQuestion(value);
  //         if (error) {
  //           formDataValidationPromises.push(Promise.resolve({ questionId, error }));
  //         }
  //       }
  //     }

  //     const validationResults = await Promise.all(formDataValidationPromises);
  //     const validationErrors = validationResults.reduce((errors, { questionId, error }) => {
  //       if (error) {
  //         errors[questionId] = error;
  //       }
  //       return errors;
  //     }, {});

  //     return Object.keys(validationErrors).length > 0 ? validationErrors : null;
  //   };


  async function getLatestRecord() {
    try {

      const selectedPlantId = localStorage.getItem("selectedPlantId");
          
      const response = await axios.get(`${ApiURL}/GET_LATEST_FIVES`, {
        headers: {
          Authorization: `Bearer ${access_token}`
        },
        params: { selectedPlantId },
      });

      //const response = await axios.get(`${API.GET_LATEST_MOC}`);
      if (response.data && response.data.length > 0) {
      
        const latestAssessmentNumber = response.data[0].ass_no;
        // console.log('Latest Assessment Number from DB:', latestAssessmentNumber);
        return latestAssessmentNumber;
        // return response.data[0].ass_no; // Return the latest MOC number
      } else {
        console.log("No data found in the response");
        return null;
      }

    } catch (error) {
      console.log("Error:", error);
      return null;
    }
  }

  //old code
  async function generateassNumber() {
    const latestRecord = await getLatestRecord();
    let lastTwoDigits = 1; // Default value if no records are found
    if (latestRecord) {
      const lastMocNumber = parseInt(latestRecord.split("-")[3]); // Extract last three digits
      lastTwoDigits = lastMocNumber + 1;
    }
    const date = new Date();
    const year = date.getFullYear().toString();
    const yearMocNumber = `AS-FL2-${year}-${lastTwoDigits
      .toString()
      .padStart(2, "0")}`;
      
console.log('yearMocNumber',yearMocNumber)
    return yearMocNumber;
  }

  // generateassNumber()
  //   .then((serialNumber) => {
  //     console.log("Generated Serial Number:", serialNumber);
  //   })
  //   .catch((error) => {
  //     console.error("Error occurred:", error);
  //   });






  const calculateOverallScoreedit = (selectedValues) => {
    let overallScore = 0;

    // Iterate through the selected values
    for (const questionId in selectedValues) {
      if (selectedValues.hasOwnProperty(questionId)) {
        // Add the score for each question to the overall score
        overallScore += parseInt(selectedValues[questionId]) || 0;
      }
    }

    return overallScore;
  };

  const calculateOverallScore = (formData) => {
    let overall = 0;
    for (const step in formData) {
      const stepData = formData[step];
      for (const questionId in stepData.selectedValues) {
        if (stepData.selectedValues.hasOwnProperty(questionId)) {
          const score = stepData.selectedValues[questionId];
          overall += parseInt(score) || 0;
        }
      }
    }
    return overall;
  };

  // FIX: keep the header "Score / 36" live as the user answers questions, instead of
  // only refreshing after a save/submit round-trip.
  useEffect(() => {
    setOverallScore(calculateOverallScore(formData));
  }, [formData]);

  // NEW: flattens selectedValues/images/remarks across ALL 6 steps (0-5) into a single
  // combined object. This is what the backend's "details" field expects - one flat
  // selectedValues/images/remarks object spanning all 36 questions - not just the
  // data for whichever single step happened to call onSave. Without this, every
  // save/update overwrote the previous steps' answers instead of merging with them.
  const mergeAllStepsData = (fd) => {
    const merged = { selectedValues: {}, images: {}, remarks: {} };
    for (let step = 0; step <= 5; step++) {
      const stepData = fd && fd[step];
      if (!stepData) continue;
      Object.assign(merged.selectedValues, stepData.selectedValues || {});
      Object.assign(merged.images, stepData.images || {});
      Object.assign(merged.remarks, stepData.remarks || {});
    }
    return merged;
  };

  // My new code
  const handleSave = async (selectedValues, images, remarks) => {
    setLoading(true);
    try {
        // Merge the just-changed step's data into the recoil-wide formData FIRST so that
        // the payload we send always contains every step's answers, not only the step
        // that triggered the save. This fixes data being wiped out step-to-step and on Submit.
        const mergedFormDataState = {
            ...formData,
            [activeStep]: { selectedValues, images, remarks },
        };
        setFormData(mergedFormDataState);

        const overallScore = calculateOverallScore(mergedFormDataState);
        console.log("scoresave",overallScore);
        setOverallScore(overallScore);

        const mergedAll = mergeAllStepsData(mergedFormDataState);

        // Images already saved on a previous step come back from the server (and from
        // geteditdetails) as full display URLs like `${ApiURL}/api/images/foo.jpg`.
        // We must store only the bare filename back to the backend, or the path prefix
        // will keep getting stacked on every subsequent save.
        const imagePrefix = `${ApiURL}/api/images/`;
        const normalizedExistingImages = Object.fromEntries(
            Object.entries(mergedAll.images).map(([questionId, value]) => {
                if (typeof value === 'string' && value.startsWith(imagePrefix)) {
                    return [questionId, value.substring(imagePrefix.length)];
                }
                return [questionId, value];
            })
        );

        const imagesData = await generateImagesArray(mergedAll.images);
        const currentFormData = {
            selectedValues: mergedAll.selectedValues,
            images: {
                ...normalizedExistingImages,
                ...Object.fromEntries(
                    Object.entries(imagesData).map(([questionId, image]) => [questionId, image.imageName])
                ),
            },
            remarks: mergedAll.remarks,
        };

        const userby = JSON.parse(localStorage.getItem("userDatas"));
        const userdet = userby.sgid.replace(/"/g, '');
        const assNumber = await generateassNumber();
        const userid = {
            userid: userdet,
            assNumber: assNumber,
            status_flg: 'P',
            auditorName: localStorage.getItem("auditor"),
            auditDate: localStorage.getItem("selectedDate"),
            zoneId: localStorage.getItem("zone"),
            overallScore: overallScore,
        };

        const assessmentId = localStorage.getItem("assessmentIdcreate");
        if (!assessmentCreated && !assessmenteditflg && !assessmentId) {
            const response = await axios.post(`${ApiURL}/create_assessment`, {
                assessmentData: currentFormData,
                userdetails: userid,
            }, {
                headers: { Authorization: `Bearer ${access_token}` },
            });
      AlertDialog({
          type: 'success',
          title: 'Success',
          text: 'Assessment created successfully.',
        });
            if (response.data.success) {
                setAssessmentId(response.data.assessmentId);
                localStorage.setItem("assessmentIdcreate", response.data.assessmentId);
                setAssessmentCreated(true);
            }
        } else {
            const assessmentEditID = localStorage.getItem("assessmentId");
            if (assessmenteditflg) {
                // FIX: previously this used calculateOverallScoreedit(selectedValues),
                // which only scored the single step that just called onSave. Use the
                // merged score across all 6 steps instead, same as the create path.
                console.log("scoreoverallEdit", overallScore);
                setOverallScore(overallScore);

                await axios.post(`${ApiURL}/update_edit_assessment/${assessmentEditID}`, {
                    assessmentData: currentFormData,
                    userdetails: { overallScore: overallScore },
                }, {
                    headers: { Authorization: `Bearer ${access_token}` },
                });
            } else {
                const response = await axios.post(`${ApiURL}/update_assessment/${assessmentId}`, {
                    assessmentData: currentFormData,
                    userdetails: userid,
                }, {
                    headers: { Authorization: `Bearer ${access_token}` },
                });
            }
        }
    } catch (error) {
        console.error('Error saving/updating assessment:', error);
    } finally {
        setLoading(false);
    }
};

const generateImagesArray = async (images) => {
    const imagesData = {};
    for (const questionId in images) {
        if (images.hasOwnProperty(questionId)) {
            const imageDataUrl = images[questionId];
            if (typeof imageDataUrl === 'string' && imageDataUrl.includes(',')) {
                const imageData = imageDataUrl.split(',');
                if (imageData.length === 2) {
                    const imageType = imageData[0].split(';')[0].split('/')[1];
                    const imageBase64 = imageData[1];
                    const imageName = `image_${Date.now()}_${questionId}.${imageType}`;
                    imagesData[questionId] = {
                        imageName,
                        imageBase64,
                        imageType,
                        questionId,
                    };
                }
            }
        }
    }
    if (Object.keys(imagesData).length > 0) {
        await uploadBlobImagesAPI(Object.values(imagesData));
    }
    return imagesData;
};

const uploadBlobImagesAPI = async (imagesData) => {
    try {
        const url = `${ApiURL}/upload_image_to_blob_v1`; 
        const response = await axios.post(url, { images: imagesData });
        if (response.status === 200) {
            setSnackbarMessage("Images uploaded successfully.");
             setSnackbarSeverity("success"); 
            setSnackbarOpen(true);
            return true;
        } else {
            setSnackbarMessage("Images not uploaded successfully.");
            setSnackbarSeverity("error");     // ❌ ERROR ICON
            setSnackbarOpen(true);
            
        }
    } catch (error) {
        console.error('Error uploading images:', error);
    }
};
//old code
  // const handleSave = async (selectedValues, images, remarks) => {
  //   setLoading(true);

  //   try {
  //     // Calculate overall score
  //     const overallScore = calculateOverallScore(formData);
  //     // Update overall score in UI or state
  //     setOverallScore(overallScore);

  //     const imagesData = await generateImagesArray();
  //    console.log("ImageData",imagesData)
  //     const currentFormData = {
  //       selectedValues,
  //       images: Object.fromEntries(
  //         Object.entries(imagesData).map(([questionId, image]) => [questionId, image.imageName])
  //       ),
  //       remarks,
  //     };

  //     const userby = JSON.parse(localStorage.getItem("userDatas"));
  //     const userdet = userby.sgid.replace(/"/g, '');
  //     const assNumber = await generateassNumber();

  //     const userid = {
  //       userid: userdet,
  //       assNumber: assNumber,
  //       status_flg: 'P',
  //       auditorName: localStorage.getItem("auditor"),
  //       auditDate: localStorage.getItem("selectedDate"),
  //       zoneId: localStorage.getItem("zone"),
  //       overallScore: overallScore,
  //     };

  //     const assesmentid = localStorage.getItem("assessmentIdcreate");
  //     if (!assessmentCreated && !assessmenteditflg && !assesmentid) {
  //       const response = await axios.post(ApiURL + '/create_assessment',
  //         { assessmentData: currentFormData, userdetails: userid },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${access_token}`
  //           },
  //         }
  //       );

  //       AlertDialog({
  //         type: 'success',
  //         title: 'Success',
  //         text: 'Assessment created successfully.',
  //       });

  //       if (response.data.success) {
  //         setAssessmentId(response.data.assessmentId);
  //         localStorage.setItem("assessmentIdcreate", response.data.assessmentId);
  //         setAssessmentCreated(true);
         
  //         setLoading(false);
  //       }
  //     } else {
  //       const assessmenteditID = localStorage.getItem("assessmentId");
  //       if (assessmenteditflg) {
  //         setOverallScore(0);
  //         const overallScoreEdit = calculateOverallScoreedit(selectedValues);
  //         setOverallScore(overallScoreEdit);

  //         const response = await axios.post(`${ApiURL}/update_edit_assessment/${assessmenteditID}`,
  //           { assessmentData: currentFormData, userdetails: { overallScore: overallScoreEdit } },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${access_token}`
  //             },
  //           }
  //         );
        
  //         //   setTimeout(() => {
  //         //     // Perform your save logic here, and then reset loading state
  //         //     setLoading(false);
  //         // }, 2000); 
  //         setLoading(false);
  //         setChangesSaved(true);
  //       } else {
  //         const assessmentId = localStorage.getItem("assessmentIdcreate");
  //         const response = await axios.post(`${ApiURL}/update_assessment/${assessmentId}`,
  //           { assessmentData: currentFormData, userdetails: userid },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${access_token}`
  //             },
  //           }
  //         );
         
  //         //   setTimeout(() => {
  //         //     // Perform your save logic here, and then reset loading state
  //         //     setLoading(false);
  //         // }, 2000); 
  //         setLoading(false);
  //         setChangesSaved(true);
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Error saving/updating assessment:', error);
  //     setLoading(false);
  //   }
  // };
// const generateImagesArray = async () => {
//   const imagesData = {};
// console.log("hello image enter")
//   for (const step in formData) {
//     if (formData.hasOwnProperty(step) && formData[step].images) {
//       const stepData = formData[step];

//       for (const questionId in stepData.images) {
//         if (stepData.images.hasOwnProperty(questionId)) {
//           const imageDataUrl = stepData.images[questionId];

//           if (typeof imageDataUrl === 'string' && imageDataUrl.includes(',')) {
//             try {
//               const imageData = imageDataUrl.split(',');
//               if (imageData.length === 2) {
//                 const imageType = imageData[0].split(';')[0].split('/')[1];
//                 const imageBase64 = imageData[1];
//                 const imageName = `image_${Date.now()}_${questionId}.${imageType}`;

            

//                 imagesData[questionId] = {
//                   imageName,
//                   imageBase64,
//                   imageType,
//                   questionId,
//                 };
//               } else {
//                 console.warn(`Skipping invalid image data for questionId: ${questionId}`);
//               }
//             } catch (error) {
//               console.error(`Error processing image data for questionId: ${questionId}`, error);
//             }
//           } else {
//             console.warn(`Skipping invalid image URL for questionId: ${questionId}`);
//           }
//         }
//       }
//     }
//   }



//   // Ensure imagesData is not empty before calling uploadBlobImagesAPI
//   if (Object.keys(imagesData).length > 0) {
//     try {
//       await uploadBlobImagesAPI(Object.values(imagesData));
//     } catch (error) {
//       console.error('Error in uploadBlobImagesAPI:', error);
//     }
//   } else {
//     console.warn('No valid images to upload.');
//   }

//   return imagesData;
// };

// const uploadBlobImagesAPI = async (imagesData) => {
//   try {
//     const url = `${ApiURL}/upload_image_to_blob_v1`; // Construct the full URL using ApiURL

//     const response = await axios.post(url, {
//       images: imagesData, // Pass the imagesData array
//     });
//     console.log("response upload image",response)
//     if (response.status === 200) {
//       setSnackbarMessage("Images uploaded successfully.");
//       setSnackbarOpen(true);
//       return true; // Indicate success
//     } else {
//       setSnackbarMessage("Images not uploaded successfully.");
//       setSnackbarOpen(true);
//       return false; // Indicate failure
//     }
//     // Handle the response and update your UI or state as needed
//   } catch (error) {
//     console.error('Error uploading images:', error);
//     // Handle error, update UI, etc.
//   }
// };

const generateImagesArrayOld = async () => {
  const imagesData = {};

    // Iterate over the keys of the formData
    for (const step in formData) {
      if (formData.hasOwnProperty(step) && formData[step].images) {
        const stepData = formData[step];

        // Iterate over the images object of each step
        for (const questionId in stepData.images) {
          if (stepData.images.hasOwnProperty(questionId)) {
            const imageDataUrl = stepData.images[questionId];

            // Check if imageDataUrl is valid
            if (typeof imageDataUrl === 'string' && imageDataUrl.includes(',')) {
              try {
                // Split data URL into "data:image/png;base64" and base64 string
                const imageData = imageDataUrl.split(',');

                // Ensure the split data URL has two parts before proceeding
                if (imageData.length === 2) {
                  const imageType = imageData[0].split(';')[0].split('/')[1]; // Extract file extension
                  const imageBase64 = imageData[1]; // Extract base64 string

                  const imageName = `image_${Date.now()}_${questionId}.${imageType}`;

                
                  // Assign the image data to imagesData with the questionId as key
                  imagesData[questionId] = {
                    imageName,
                    imageBase64,
                    imageType,
                    questionId,
                  };
                } else {
                  console.warn(`Skipping invalid image data for questionId: ${questionId}`);
                }
              } catch (error) {
                console.error(`Error processing image data for questionId: ${questionId}`, error);
              }
            } else {
              console.warn(`Skipping invalid image URL for questionId: ${questionId}`);
            }
          }
        }
      }
    }

 

    // Call the upload function after processing the images
    await uploadBlobImagesAPI(Object.values(imagesData));

    // Return the imagesData object
    return imagesData;
  };




const uploadBlobImagesAPIOLD = async (imagesData) => {
  try {
      const url = `${ApiURL}/upload_image_to_blob_v1`; // Construct the full URL using ApiURL

      const response = await axios.post(url, {
        images: imagesData, // Pass the imagesData array
      });

  
      // Handle the response and update your UI or state as needed
    } catch (error) {
      console.error('Error uploading images:', error);
      // Handle error, update UI, etc.
    }
  };



const generateImagesArray_lat = async () => {
  const imagesData = {};

  // Iterate over the keys of the formData
  for (const step in formData) {
    if (formData.hasOwnProperty(step) && formData[step].images) {
      const stepData = formData[step];

      // Iterate over the images object of each step
      for (const questionId in stepData.images) {
        if (stepData.images.hasOwnProperty(questionId)) {
          const imageDataUrl = stepData.images[questionId];

          // Check if imageDataUrl is valid
          if (typeof imageDataUrl === 'string' && imageDataUrl.includes(',')) {
            try {
              // Split data URL into "data:image/png;base64" and base64 string
              const imageData = imageDataUrl.split(',');

              // Ensure the split data URL has two parts before proceeding
              if (imageData.length === 2) {
                const imageType = imageData[0].split(';')[0].split('/')[1]; // Extract file extension
                const imageBase64 = imageData[1]; // Extract base64 string

                const imageName = `image_${Date.now()}_${questionId}.${imageType}`;

           
                // Assign the image data to imagesData with the questionId as key
                imagesData[questionId] = {
                  imageName,
                  imageBase64,
                  imageType,
                  questionId,
                };
              } else {
                console.warn(`Skipping invalid image data for questionId: ${questionId}`);
              }
            } catch (error) {
              console.error(`Error processing image data for questionId: ${questionId}`, error);
            }
          } else {
            console.warn(`Skipping invalid image URL for questionId: ${questionId}`);
          }
        }
      }
    }
  }


  // Call the upload function after processing the images
  await uploadBlobImagesAPI(Object.values(imagesData));

  // Return the imagesData object
  return imagesData;
};





  useEffect(() => {
    console.log("open",open)
    if (assessmenteditflg && open) {
      const assessmentId = localStorage.getItem("assessmentId");

      geteditdetails(assessmentId);
    } else if (open) {
      // Not editing an existing record - nothing to wait on, render immediately.
      setEditDataLoaded(true);
    }
    // FIX: was [] (mount-only), so re-opening the dialog for edit after it had already
    // mounted once never re-fetched the saved answers. Now it reacts to `open`.
  }, [open, assessmenteditflg]);

  // Whenever the active step changes, scroll the dialog content to top
  useEffect(() => {
    try {
      if (contentRef.current && typeof contentRef.current.scrollTo === 'function') {
        contentRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
    } catch (e) {
      console.warn('scroll on activeStep change failed', e);
    }
  }, [activeStep]);

  // Question groupings per step - mirrors the grouping used in Safety.js's
  // handleFinalSubmit, needed to split the backend's flat selectedValues/images/remarks
  // (which span all 36 questions) back into the per-step buckets that formDataState uses.
  const stepQuestionGroups = {
    0: ['question1', 'question2', 'question3'],
    1: ['question4', 'question5', 'question6', 'question7', 'question8', 'question9', 'question10', 'question11', 'question12', 'question13', 'question14'],
    2: ['question15', 'question16', 'question17', 'question18', 'question19', 'question20'],
    3: ['question21', 'question22', 'question23', 'question24', 'question25'],
    4: ['question26', 'question27', 'question28', 'question29'],
    5: ['question30', 'question31', 'question32', 'question33', 'question34', 'question35', 'question36'],
  };

  const pickKeys = (obj, keys) => {
    const out = {};
    (keys || []).forEach((k) => {
      if (obj && obj.hasOwnProperty(k)) out[k] = obj[k];
    });
    return out;
  };

  // FIX: this used to only read `total_score` and set the score, without ever loading
  // the actual saved answers/images/remarks into formDataState. That's why re-opening
  // an assessment for edit and jumping between steps showed blank fields, and why any
  // edits made were saved on top of an otherwise-empty record. Now it loads the full
  // "details" payload once, up front, and hydrates every step of formDataState so each
  // step component (and handleSave's merge logic) starts from the real saved data.
  async function geteditdetails(assessmentId) {
    try {
      setActiveStep(0)
      setEditDataLoaded(false);
      const response = await axios.get(`${ApiURL}/get_AssessmentByIds/${assessmentId}`, {
        headers: {
          Authorization: `Bearer ${access_token}`
        }
      });
      if (response.data && response.data.data) {
        console.log("responseedit", response.data)
        const scoreValue = parseInt(response.data.data.total_score, 10);
        setOverallScore(isNaN(scoreValue) ? 0 : scoreValue);

        if (response.data.data.details) {
          const details = JSON.parse(response.data.data.details);
          const savedSelectedValues = details.selectedValues || {};
          const savedRemarks = details.remarks || {};
          const savedImages = details.images || {};

          const imagePrefix = `${ApiURL}/api/images/`;
          const hydratedFormData = {};
          for (let step = 0; step <= 5; step++) {
            const questions = stepQuestionGroups[step];
            const stepImages = pickKeys(savedImages, questions);
            const stepImagesWithPaths = Object.fromEntries(
              Object.entries(stepImages).map(([questionId, imageName]) => [
                questionId,
                typeof imageName === 'string' && imageName.startsWith(imagePrefix)
                  ? imageName
                  : `${imagePrefix}${imageName}`,
              ])
            );
            hydratedFormData[step] = {
              selectedValues: pickKeys(savedSelectedValues, questions),
              remarks: pickKeys(savedRemarks, questions),
              images: stepImagesWithPaths,
            };
          }

          setFormData(hydratedFormData);
        }
      } else {
        console.log("No data found in the response");
      }
    } catch (error) {
      console.log("Error:", error);
      return null;
    } finally {
      // Flip this last, after formData has been set, so step components mount
      // (or re-render) only once the freshly-scoped data is already in place.
      setEditDataLoaded(true);
    }
  }




  const renderStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <RequestForm onNext={onNext} activeStep={activeStep} onSave={handleSave} loading={loading} />;
      case 1:
        return <Straighten onNext={onNext} activeStep={activeStep} onSave={handleSave} loading={loading} />;
      case 2:
        return <Shine onNext={onNext} activeStep={activeStep} onSave={handleSave} loading={loading} />;
      case 3:
        return <Standardise onNext={onNext} activeStep={activeStep} onSave={handleSave} loading={loading} />;
      case 4:
        return <Sustain onNext={onNext} activeStep={activeStep} onSave={handleSave} loading={loading} />;
      case 5:
        return <Safety onNext={onNext} activeStep={activeStep} onSave={handleSave} loading={loading} />;
      default:
        return null;
    }
  };
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog open={open} fullScreen={fullScreen} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center ' }}>
       {/* <IconButton onClick={onClose} 
         style={{ 
          position: 'absolute', 
          top: '5px', 
          right: '8px' 
        }}
       
        >
            <CloseIcon />
          </IconButton>*/}
          {activeStep === 0 && (
            <Box style={{ flexGrow: 1 }}>
              <Typography variant="h6" style={{ textTransform: 'uppercase', fontSize: "16px", fontWeight: '600', color: '#17428B', marginBottom: '10px' }}>1S: Sort(seiri)</Typography>
              <p style={{ marginBottom: '10px', fontSize: "10px", fontWeight: '500' }}>Tidiness, Organization. Refers To The Practice Of Sorting Through All The Tools, Materials, Etc., In The Work Area And Keeping Only Essential Items.</p>
            </Box>
          )}
          {activeStep === 1 && (
            <Box style={{ flexGrow: 1 }}>
              <Typography variant="h6" style={{ textTransform: 'uppercase', fontSize: "16px", fontWeight: '600', color: '#17428B', marginBottom: '10px' }}>2S: STRAIGHTEN(SEITON)</Typography>
              <p style={{ marginBottom: '10px', fontSize: "10px", fontWeight: '500' }}>Focuses on the need for an orderly workplace. Tools, equipment, and materials must be systematically arranged for the easiest and most efficient access.</p>
            </Box>
          )}
          {activeStep === 2 && (
            <Box style={{ flexGrow: 1 }}>
              <Typography variant="h6" style={{ textTransform: 'uppercase', fontSize: "16px", fontWeight: '600', color: '#17428B', marginBottom: '10px' }}>3S: SHINE(SEISO)</Typography>
              <p style={{ marginBottom: '10px', fontSize: "10px", fontWeight: '500' }}>Indicates the need to keep the workplace clean as well as neat. Cleaning in Japanese companies is a daily activity.</p>
            </Box>
          )}
          {activeStep === 3 && (
            <Box style={{ flexGrow: 1 }}>
              <Typography variant="h6" style={{ textTransform: 'uppercase', fontSize: "16px", fontWeight: '600', color: '#17428B', marginBottom: '10px' }}>4S: STANDARDISE (SEIKETSU)</Typography>
              <p style={{ marginBottom: '10px', fontSize: "10px", fontWeight: '500' }}>Allows for control and consistency. Basic housekeeping standards apply everywhere in the facility.</p>
            </Box>
          )}
          {activeStep === 4 && (
            <Box style={{ flexGrow: 1 }}>
              <Typography variant="h6" style={{ textTransform: 'uppercase', fontSize: "16px", fontWeight: '600', color: '#17428B', marginBottom: '10px' }}>5S: SUSTAIN(SHITSUKE)</Typography>
              <p style={{ marginBottom: '10px', fontSize: "10px", fontWeight: '500' }}>Refers to maintaining standards and keeping the facility in safe and efficient order day after day, year after year.</p>
            </Box>
          )}
          {activeStep === 5 && (
            <Box style={{ flexGrow: 1 }}>
              <Typography variant="h6" style={{ textTransform: 'uppercase', fontSize: "16px", fontWeight: '600', color: '#17428B', marginBottom: '10px' }}>6S : SAFETY</Typography>
              <p style={{ marginBottom: '10px', fontSize: "10px", fontWeight: '500' }}>Tidiness, Organization. Refers To The Practice Of Sorting Through All The Tools, Materials, Etc., In The Work Area And Keeping Only Essential Items.</p>
            </Box>
          )}
          <Typography style={{ marginBottom: '10px', fontSize: "18px", fontWeight: '600', color: '#4FB0B4', display: 'flex', flexDirection: 'column', alignItems: 'end',paddingLeft:'16px' }}> <Typography variant='small' sx={{fontWeight:'400',fontSize:'12px'}}>Score</Typography>{`${overallScore}/36`}</Typography>
        </Box>
        <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0' }}>
          {steps.map((step, index) => (
            <Box key={index} style={{ flex: 1, position: 'relative', marginRight: '10px' }}>
              <Box
                onClick={() => onStepClick(index)}
                style={{
                  borderBottom: `5px solid ${stepColors[index]}`,
                  width: '100%',
                  marginBottom: '10px',
                  marginTop: '10px',
                  borderRadius: '7px',
                  cursor: 'pointer'
                }}
              />
            </Box>
          ))}
        </Box>
        {/* {steps[activeStep]} */}
      </DialogTitle>
      <DialogContent ref={contentRef}>


        {/* Render stepper content */}

        {/* Render components based on active step */}
        {editDataLoaded ? (
          <Box>{renderStepComponent()}</Box>
        ) : (
          <Box style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
            <Typography>Loading assessment data...</Typography>
          </Box>
        )}
        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose}  severity={snackbarSeverity}>
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>

        {/* <NewAssessment
              open={isNewAssessmentOpen}
              onClose={handleCloseNewAssessment}
              onNext={({ auditor, zone, selectedDate }) => {
                setSelectedAuditDate(selectedDate);
                setSelectedAuditor(auditor);
                setSelectedZone(zone);
              }}
            /> */}
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>

  );

}

export default HorizontalCombinedStepper;